import { HttpClient } from '@angular/common/http';
import { environment } from '../../environments/environment';
import * as i0 from "@angular/core";
import * as i1 from "@angular/common/http";
export class ProductGroupsService {
    http;
    apiUrl = `${environment.base}/product-groups`;
    constructor(http) {
        this.http = http;
    }
    findAll(ctx) {
        return this.http.get(this.apiUrl, { params: ctx });
    }
    findOne(id) {
        return this.http.get(`${this.apiUrl}/${id}`);
    }
    findAttributes(productGroupId) {
        return this.http.get(`${this.apiUrl}/${productGroupId}/attributes`);
    }
    createAttribute(productGroupId, productAttribute) {
        return this.http.post(`${this.apiUrl}/${productGroupId}/attributes`, productAttribute);
    }
    updateAttribute(id, productAttribute) {
        return this.http.put(`${this.apiUrl}/${id}/attributes`, productAttribute);
    }
    removeAttribute(id) {
        return this.http.delete(`${this.apiUrl}/attributes/${id}`);
    }
    create(productGroup) {
        return this.http.post(this.apiUrl, productGroup);
    }
    update(id, productGroup) {
        return this.http.patch(`${this.apiUrl}/${id}`, productGroup);
    }
    remove(id) {
        return this.http.delete(`${this.apiUrl}/${id}`);
    }
    static ɵfac = function ProductGroupsService_Factory(t) { return new (t || ProductGroupsService)(i0.ɵɵinject(i1.HttpClient)); };
    static ɵprov = /*@__PURE__*/ i0.ɵɵdefineInjectable({ token: ProductGroupsService, factory: ProductGroupsService.ɵfac, providedIn: 'root' });
}
